<template>
  <div id="app">
    <transition name="fade">
    <!-- <keep-alive> -->
      <router-view></router-view>
    <!-- </keep-alive>  -->
   
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { detectZoom } from "./utils/utils";
import { BLACK_ROUTE_PATH } from "./page/commons/BoskTabNavigation/constant";
const lodash = require("lodash");
export default {
  name: "App",
  data() {
    return {
      blackRoutePath:[]
    };
  },
  computed: {
    ...mapGetters('tabNavigation',['currentNavigationList'])
  },
  created(){
    this.blackRoutePath=[...BLACK_ROUTE_PATH]
  },
  mounted() {
    window.onresize = () => {
      const m = detectZoom();
   
      // if (m > 125) {
      //   document.body.style.zoom = 100 / Number(m);
      // }
      // if (m < 100) {
      //   document.body.style.zoom = 1;
      // }
    };
  },
  watch: {
    $route: {
      handler(newArr, arr) {
        const { name, path } = newArr;
       
        BLACK_ROUTE_PATH.some((item) => item === path)
          ? this.setShowTabNavigation(false)
          : this.setShowTabNavigation(true);
        this.addNavigation({ name, path });
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("tabNavigation", ["addNavigation", "setShowTabNavigation"]),
    onComponentActivated(component) {
      console.log("App Component activated:", component);
    },
  },
};
</script>

<style>
/* @media all and (-moz-min-device-pixel-ratio: 1.09) and (-moz-max-device-pixel-ratio: 1.18),
  (-webkit-min-device-pixel-ratio: 1.09) and (-webkit-max-device-pixel-ratio: 1.18),
  (min-resolution: 1.09dppx) and (max-resolution: 1.18dppx) {
  #app{
    font-size: 14px;
  }
}
@media all and (-moz-min-device-pixel-ratio: 1.19) and (-moz-max-device-pixel-ratio: 1.28),
  (-webkit-min-device-pixel-ratio: 1.19) and (-webkit-max-device-pixel-ratio: 1.28),
  (min-resolution: 1.19dppx) and (max-resolution: 1.28dppx) {
  #app {
    font-size: 13px;
  }
}
@media all and (-moz-min-device-pixel-ratio: 1.29) and (-moz-max-device-pixel-ratio: 1.4),
  (-webkit-min-device-pixel-ratio: 1.29) and (-webkit-max-device-pixel-ratio: 1.4),
  (min-resolution: 1.29dppx) and (max-resolution: 1.4dppx) {
  #app{
    font-size: 12px;
  }
}
@media all and (-moz-min-device-pixel-ratio: 1.41) and (-moz-max-device-pixel-ratio: 1.6),
  (-webkit-min-device-pixel-ratio: 1.41) and (-webkit-max-device-pixel-ratio: 1.6),
  (min-resolution: 1.41dppx) and (max-resolution: 1.6dppx) {
 #app {
    font-size: 10px;
  }
}
@media all and (-moz-min-device-pixel-ratio: 1.61) and (-moz-max-device-pixel-ratio: 1.8),
  (-webkit-min-device-pixel-ratio: 1.61) and (-webkit-max-device-pixel-ratio: 1.8),
  (min-resolution: 1.61dppx) and (max-resolution: 1.8dppx) {
   #app {
    font-size: 9px;
  }
}
@media all and (-moz-min-device-pixel-ratio: 1.81) and (-moz-max-device-pixel-ratio: 2.1),
  (-webkit-min-device-pixel-ratio: 1.81) and (-webkit-max-device-pixel-ratio: 2.1),
  (min-resolution: 1.81dppx) and (max-resolution: 2.1dppx) {
  #app {
    font-size: 8px;
  }
} */
#app {
  /*background:white;*/
  /* display:table-cell; */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.6;
}

/* 暂时移除隐藏天地图图标的样式，确保地图能正常显示 */
/* 隐藏天地图版权信息和图标 - 只隐藏版权相关元素，不影响地图显示 */
/* .TDMap_cpyCtrl,
.anchorBL,
.anchorTR,
.anchorTL,
.anchorBR {
  display: none !important;
} */

/* 隐藏所有地图容器中的版权控件 */
/* #map .TDMap_cpyCtrl,
#map .anchorBL,
#map .anchorTR,
#map .anchorTL,
#map .anchorBR,
#areaMap .TDMap_cpyCtrl,
#areaMap .anchorBL,
#areaMap .anchorTR,
#areaMap .anchorTL,
#areaMap .anchorBR,
.monitoring-map .TDMap_cpyCtrl,
.monitoring-map .anchorBL,
.monitoring-map .anchorTR,
.monitoring-map .anchorTL,
.monitoring-map .anchorBR {
  display: none !important;
} */

/* 隐藏天地图版权链接和图片 - 只针对版权相关的元素 */
/* #map a[href*="tianditu.gov.cn"]:not([class*="map"]),
#map img[src*="tianditu.gov.cn"]:not([class*="map"]),
#map img[alt*="天地图"],
#map img[alt*="国家基础地理信息中心"],
#areaMap a[href*="tianditu.gov.cn"]:not([class*="map"]),
#areaMap img[src*="tianditu.gov.cn"]:not([class*="map"]),
#areaMap img[alt*="天地图"],
#areaMap img[alt*="国家基础地理信息中心"],
.monitoring-map a[href*="tianditu.gov.cn"]:not([class*="map"]),
.monitoring-map img[src*="tianditu.gov.cn"]:not([class*="map"]),
.monitoring-map img[alt*="天地图"],
.monitoring-map img[alt*="国家基础地理信息中心"] {
  display: none !important;
} */
</style>
